{
  "common": {
    "search": "Search...",
    "filter": "Filter",
    "all": "All",
    "actions": "Actions",
    "view": "View",
    "viewDetails": "View Details",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "saveChanges": "Save Changes",
    "download": "Download",
    "print": "Print",
    "status": "Status",
    "date": "Date",
    "amount": "Amount",
    "total": "Total",
    "currency": "Currency",
    "notes": "Notes",
    "loading": "Loading...",
    "noData": "No data available",
    "success": "Success",
    "error": "Error",
    "close": "Close",
    "submit": "Submit",
    "branch": "Branch",
    "previous": "Previous",
    "next": "Next",
    "critical": "Critical",
    "active": "Active",
    "target": "Target",
    "completed": "Completed",
    "finalized": "Finalized",
    "inProgress": "In Progress",
    "pastDue": "Past Due",
    "voided": "Voided",
    "corporate": "Corporate",
    "current": "Current",
    "statusApproved": "Approved",
    "statusDraft": "Draft",
    "statusPending": "Pending",
    "statusOverdue": "Overdue",
    "statusPaid": "Fully Paid",
    "statusPartial": "Partial Payment",
    "statusDeposit": "Deposit Paid",
    "statusCancelled": "Cancelled",
    "statusRejected": "Rejected",
    "statusTentative": "Tentative",
    "statusConfirmed": "Confirmed",
    "updatedBy": "Updated By",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "downloadImage": "Download Image",
    "selected": "selected",
    "exportSelected": "Export Selected",
    "deleteSelected": "Delete Selected",
    "noFile": "No file",
    "done": "Done",
    "refresh": "Refresh",
    "copied": "Copied!",
    "copiedConfirmation": "Confirmation # copied to clipboard",
    "generateReceipt": "Generate Receipt",
    "generateDepositReceipt": "Generate Deposit Receipt",
    "directDepositReceipt": "Direct Deposit Receipt",
    "viewStandaloneReceipts": "View Standalone Receipts List",
    "downloadReceipt": "Download Receipt",
    "officialReceipt": "Official Receipt",
    "depositReceipt": "Deposit Receipt",
    "receiptNo": "Receipt #"
  },
  "nav": {
    "overview": "Overview",
    "external": "External",
    "internal": "Internal",
    "others": "Others",
    "dashboard": "Dashboard",
    "confirmations": "Confirmations",
    "invoices": "Confirmations",
    "requests": "Requests",
    "companies": "Companies",
    "hotelReservations": "Hotel Reservations",
    "myExpenses": "My Expenses",
    "submitExpense": "Submit Expense",
    "approvals": "Approvals",
    "settings": "Settings",
    "superAdmin": "Super Admin",
    "comingSoon": "coming soon"
  },
  "header": {
    "operatingBranch": "Operating Branch:",
    "notifications": "Notifications",
    "all": "All",
    "systemLog": "System Log",
    "markAllRead": "Mark all as read",
    "noNotifications": "No notifications in this category.",
    "settings": "Settings",
    "switchAccount": "Switch Account",
    "language": "Language",
    "superAdminDashboard": "Super Admin Dashboard",
    "logOut": "Log Out"
  },
  "dashboard": {
    "welcome": "Welcome",
    "systemName": "ODST Group Finance System",
    "totalRevenue": "Total Revenue",
    "totalConfirmations": "Total Confirmations",
    "pendingApprovals": "Pending Approvals",
    "outstandingBalance": "Outstanding Balance",
    "overdueBalance": "Overdue Balance",
    "recentConfirmations": "Recent Confirmations",
    "seeAllConfirmations": "See All Confirmations",
    "approvalQueue": "Approval Queue",
    "awaitingReview": "Awaiting review",
    "actionRequired": "Action Required",
    "branchPerformance": "Branch Performance",
    "revenueShare": "Revenue Share",
    "revenueShareLabel": "Revenue Share",
    "monthlyRevenueTrend": "Monthly Revenue Trend",
    "quarterlyGrowth": "Quarterly Growth",
    "ref": "Ref #",
    "client": "Client",
    "confDate": "Confirmation Date",
    "dueDate": "Due Date",
    "acrossAllOffices": "Across all active offices",
    "activeLedgerRecords": "Active ledger records",
    "requiresReview": "Requires review",
    "pendingSettlement": "Pending settlement",
    "overdueConfirmation": "overdue confirmation",
    "overdueConfirmations": "overdue confirmations",
    "financialReport": "Financial Report",
    "performanceSummary": "Performance Summary",
    "growthQoQ": "Growth (QoQ)",
    "outstanding": "Outstanding",
    "quarterlyFinancialComparison": "Quarterly Financial Comparison",
    "metric": "Metric",
    "change": "Change",
    "revenue": "Revenue",
    "netProfit": "Net Profit",
    "profitMargin": "Profit Margin",
    "invoiceDistributionOverview": "Invoice Distribution Overview",
    "totalSent": "Total Sent",
    "dataConsolidatedFor": "Data consolidated for",
    "exportPdfReport": "Export PDF Report"
  },
  "invoices": {
    "title": "Confirmations Ledger",
    "subtitle": "Track advance payments, deposit ledgers, installment breakdown, and overpayment credit balances.",
    "createConfirmation": "Create Confirmation",
    "exportCsv": "Export CSV",
    "batchDelete": "Delete Selected",
    "searchPlaceholder": "Search by ref #, client, or company...",
    "recentApprovedConfirmations": "Recent Approved Confirmations",
    "allBranches": "All Branches",
    "allStatuses": "All Statuses",
    "allCompanies": "All Companies",
    "awaitingClearance": "Awaiting Clearance",
    "clearedSubtext": "Successfully processed & settled",
    "serialNo": "Serial #",
    "paidAmount": "Paid",
    "remaining": "Remaining",
    "advancePayment": "Advance Payment",
    "addPayment": "Record Payment",
    "paymentHistory": "Payment History",
    "recordNewPayment": "Record New Payment",
    "paymentDate": "Payment Date",
    "paymentProof": "Payment Proof",
    "creditBalanceExcess": "Credit excess payment to client balance",
    "itemizedCharges": "Itemized Charges",
    "serviceDescription": "Service Description",
    "unitPrice": "Unit Price",
    "qty": "Qty",
    "subtotal": "Subtotal",
    "showing": "Showing",
    "of": "of",
    "approvedInvoices": "approved confirmations",
    "confirmationDetails": "Confirmation Details",
    "reviewBillingDetails": "Review billing details",
    "generateNewConfirmation": "Generate New Confirmation",
    "editConfirmation": "Edit Confirmation",
    "modifyConfirmationSubtitle": "Modify confirmation details before resubmission",
    "confirmationNumber": "Confirmation Number",
    "referenceNumber": "Reference Number",
    "serialNumber": "Serial Number",
    "confirmationDate": "Confirmation Date",
    "dueDate": "Due Date",
    "billFrom": "Bill From",
    "billTo": "Bill To",
    "clientCompany": "Client Company",
    "clientSelection": "Company Name / Client Selection",
    "selectClientCompany": "Select client company...",
    "pleaseSelectCompany": "Please select a company",
    "entityCompany": "Entity / Company",
    "companyTaxNumber": "Company Tax Number",
    "streetAddress": "Street Address",
    "cityCountry": "City / Country",
    "phone": "Phone Number",
    "description": "Description",
    "itemizedCharges": "Itemized Charges",
    "itemDescription": "Item Description",
    "qty": "Qty",
    "unitPrice": "Unit Price",
    "total": "Total",
    "subtotal": "Subtotal",
    "totalDue": "Total Due",
    "taxVat": "Tax / VAT",
    "hasAdvancePayment": "Has Advance Payment?",
    "advancePaymentAmount": "Advance Payment Amount",
    "selectService": "Select Service",
    "chooseConfiguredService": "Choose configured service...",
    "addCustomItem": "Add Custom Item",
    "paymentInstructions": "Payment Instructions",
    "bankName": "Bank Name",
    "accountName": "Account Name",
    "idrAccountNumber": "IDR Account Number",
    "usdAccountNumber": "USD Account Number",
    "bankBranchAddress": "Bank Branch Address",
    "cifNumber": "CIF / Company Number",
    "swiftCode": "SWIFT Code",
    "notes": "Notes",
    "termsAndConditions": "Terms & Conditions",
    "systemStatus": "System status",
    "viewPaymentProof": "View Payment Proof",
    "uploadProof": "Upload Proof",
    "print": "Print",
    "downloadPdf": "Download PDF",
    "verifying": "Verifying...",
    "errorsFound": "errors found. Please fix them before submitting.",
    "dueDateFuture": "Due date must be in the future",
    "validationFailed": "Validation failed: Fix errors to proceed",
    "formStatusValid": "Form status: Valid & complete",
    "saveAndResubmit": "Save & Resubmit",
    "generateConfirmation": "Generate Confirmation",
    "currency": "Currency",
    "noCompaniesAvailable": "No companies available. Please add a company in Settings or Companies page first.",
    "agent": "Agent",
    "othersClient": "Others / Custom Client",
    "customClientInfo": "One-Off / Not saved to Master Data",
    "customCompanyNameRequired": "Client company name is required",
    "additionalInformation": "Additional Information (Optional)",
    "additionalInformationDesc": "Optional group identifier and nationality details.",
    "groupNumber": "Group Number",
    "groupNumberPlaceholder": "e.g. GRP-2026-JKT01",
    "nationality": "Nationality",
    "nationalityPlaceholder": "e.g. Indonesian / Saudi",
    "paymentHistoryTitle": "Payment History & Balance Management",
    "confirmation": "Confirmation",
    "totalBilled": "Total Billed",
    "totalPaid": "Total Paid",
    "remainingDue": "Remaining Due",
    "installmentsLedger": "Installments Ledger",
    "addPayment": "Add Payment",
    "addPaymentApprovalNote": "🔒 Add payment unlocks after Level 4 Approval",
    "date": "Date",
    "amount": "Amount",
    "recordedBy": "Recorded By",
    "proof": "Proof",
    "viewProof": "View Proof",
    "noInstallmentsRecorded": "No installment payments recorded yet.",
    "editPaymentRecord": "Edit Payment Record",
    "recordNewPayment": "Record New Payment",
    "paymentAmount": "Payment Amount",
    "enterAmountPaid": "Enter amount paid...",
    "paymentDate": "Payment Date",
    "uploadPaymentProof": "Upload Payment Proof (Transfer Receipt)",
    "attachProofFile": "Attach proof file (Image/PDF)...",
    "paymentNote": "Payment Note (Optional)",
    "paymentNotePlaceholder": "e.g. Bank transfer, receipt reference...",
    "overpaymentDetected": "Overpayment Detected (+{{amount}})",
    "saveExcessCredit": "Save excess as credit balance for {{company}}?",
    "savePayment": "Save Payment",
    "deletePaymentConfirmTitle": "Delete Payment Record?",
    "deletePaymentConfirmDesc": "Are you sure you want to delete this payment record? Remaining balance will be automatically recalculated.",
    "uploadingPaymentProof": "Uploading Payment Proof",
    "convertingImage": "Converting image and uploading to server. Please wait...",
    "paymentProofViewerTitle": "Payment Transfer Photo / PDF",
    "downloadImage": "Download Image",
    "confirmationAutoApproved": "Confirmation Auto-Approved",
    "bypassApprovedDesc": "Direct bypass active. Your confirmation has been approved and is ready for download.",
    "confirmationGeneratedSuccess": "Confirmation Generated Successfully",
    "confirmationGeneratedDesc": "Your confirmation has been generated. Would you like to send a request to get approval for payment?",
    "noThanks": "No, Thanks",
    "sendRequest": "Send Request",
    "requestSentSuccess": "Request Sent Successfully",
    "requestSentDesc": "Your approval request has been sent successfully. You will be notified once it is approved.",
    "viewPdf": "View / PDF"
  },
  "requests": {
    "title": "Approval Requests",
    "subtitle": "Review, approve, or reject multi-level service and invoice approval requests.",
    "allRequests": "All Requests",
    "allRequestsListing": "All Confirmation Requests Listing",
    "myApprovals": "My Approvals",
    "approved": "Approved",
    "rejected": "Rejected",
    "searchPlaceholder": "Search requests or company...",
    "level1": "Chief Accountant (L1)",
    "level2": "Approver (L2)",
    "level3": "Division Director (L3)",
    "level4": "Financial Controller (L4)",
    "approve": "Approve",
    "reject": "Reject",
    "approvalNote": "Approval Note",
    "rejectionReason": "Rejection Reason",
    "provideReason": "Please provide reason for rejection",
    "submittedBy": "Submitted By",
    "submissionDate": "Submission Date",
    "showing": "Showing",
    "of": "of",
    "totalRequests": "total requests",
    "fullyApprovedBanner": "This invoice has been fully approved and is ready for payment. All necessary signatures have been consolidated.",
    "rejectedConfirmationDetails": "Rejected Confirmation Details",
    "fullyApprovedConfirmationDetails": "Fully Approved Confirmation Details",
    "reviewRequest": "Review Request",
    "confirmationRequests": "Confirmation Requests",
    "requestNumber": "Request",
    "backToListing": "Back to Listing",
    "approvalWorkflow": "Approval Workflow",
    "approvalWorkflowStatus": "Approval Workflow Status",
    "awaitingReview": "Awaiting Review",
    "pending": "Pending",
    "chiefAccountant": "Chief Accountant",
    "level2Approvers": "Level 2 Approvers",
    "level3Approvers": "Level 3 Approvers",
    "umrahDivisionDirector": "Umrah Division Director",
    "financialController": "Financial Controller",
    "approvalsComplete": "Approvals Complete",
    "readyForPayment": "Ready for payment execution.",
    "requestRejected": "Request Rejected",
    "approvalsProgress": "{{count}} of 4 Approvals Complete",
    "pendingLevelAction": "Pending Level {{level}} action before proceeding.",
    "waitingForLevel": "Waiting for Level {{level}} approval",
    "awaitingReviewYourLevel": "Awaiting Review (Your Level)",
    "paymentTransferPhoto": "Payment Transfer Photo",
    "paymentProofPdf": "Payment Proof PDF",
    "clickToViewPdf": "Click to View PDF Document",
    "clickToViewFullSize": "🔍 Click to View Full Size",
    "deleteProof": "Delete Proof",
    "changeDocument": "Change Document",
    "noProofUploaded": "No payment proof document uploaded yet.",
    "uploadProofPdfImg": "Upload Proof (PDF/Image)",
    "availableOperations": "Available Operations",
    "reviewPaymentInstructions": "Mr. Emad, please review the uploaded payment proof below. If the proof is correct, approve the payment.",
    "rejectPayment": "Reject Payment",
    "approvePayment": "Approve Payment",
    "awaitingPaymentApprovalNotice": "Payment proof uploaded and submitted. Awaiting approval from Mr. Emad Moustafa.",
    "markedAsPaid": "Marked as Paid",
    "executePayment": "Execute Payment",
    "submitPaymentForApproval": "Submit Payment for Approval",
    "sendConfirmation": "Send Confirmation",
    "printConfirmation": "Print Confirmation",
    "downloadPdf": "Download PDF",
    "editAndResubmit": "Edit and Resubmit",
    "archiveConfirmation": "Archive Confirmation",
    "decisionInfo": "Please review all details carefully before making your decision. This action cannot be undone.",
    "yourDecision": "Your Decision (Level {{level}})",
    "decisionSubtitle": "As {{role}}, confirm or reject this confirmation request.",
    "approvalNoteOptional": "Approval Note (Optional)",
    "addNotePlaceholder": "Add an optional note to accompany your decision...",
    "approveAndSign": "Approve & Sign Confirmation",
    "rejectRequest": "Reject Request",
    "employeeName": "Employee Name",
    "employeeId": "Employee ID",
    "companyEmail": "Company Email",
    "sendConfirmationToClient": "Send Confirmation to Client",
    "sendConfirmationDesc": "This will automatically generate a beautifully styled HTML confirmation document and send it directly to the customer's billing email.",
    "recipientEmailAddress": "Recipient Email Address",
    "sendEmail": "Send Email",
    "sending": "Sending...",
    "confirmationSent": "Confirmation Sent!",
    "confirmationSentDesc": "The confirmation email has been successfully sent to",
    "paymentPhotoPdf": "Payment Transfer Photo / PDF",
    "downloadImage": "Download Image",
    "areYouSure": "Are you sure?",
    "confirmMarkPaid": "Do you want to mark this as paid?",
    "yesConfirm": "Yes, Confirm",
    "confirmationMarkedAsPaid": "Confirmation Marked as Paid!",
    "transactionRecorded": "The transaction has been successfully recorded.",
    "archiveRequestTitle": "Archive Request?",
    "archiveRequestDesc": "Are you sure you want to archive this invoice request? This action cannot be undone.",
    "yesArchive": "Yes, Archive",
    "confirmationArchived": "Confirmation Request Archived!",
    "confirmationArchivedDesc": "The confirmation request has been successfully archived.",
    "provideRejectionReason": "Provide Rejection Reason",
    "reasonOfRejection": "Reason of Rejection",
    "rejectionReasonPlaceholder": "Enter the reason why this invoice is rejected..."
  },
  "companies": {
    "title": "Client Company Directory",
    "subtitle": "Manage client company profiles, credit balances, payment ledgers, and contact information.",
    "addCompany": "Add Company",
    "addNewCompany": "Add New Company",
    "editCompanyDetails": "Edit Company Details",
    "companyDetails": "Company Details",
    "companyCode": "Company Code",
    "companyName": "Company Name",
    "phoneNumber": "Phone Number",
    "streetAddress": "Street Address",
    "city": "City",
    "postalCode": "Postal Code",
    "country": "Country",
    "taxIdentificationNumber": "Tax Identification Number",
    "agent": "Agent",
    "noAgent": "None (No Agent)",
    "unique3LetterIdentifier": "Unique 3-letter identifier",
    "creditBalance": "Credit Balance",
    "resetCredit": "Reset Credit",
    "resetCreditConfirm": "Reset credit balance for {{name}} to SAR 0.00?",
    "resetCreditSuccess": "Credit balance reset to 0 successfully.",
    "address": "Address",
    "cityCountry": "City / Country",
    "taxNo": "Tax Number",
    "taxId": "Tax ID",
    "contactAgent": "Agent",
    "searchPlaceholder": "Search company by name, code, or city...",
    "financialReport": "Financial Report",
    "registeredRegions": "Registered across all regions",
    "corporate": "Corporate",
    "showing": "Showing",
    "of": "of",
    "registeredCompanies": "registered companies",
    "noCompaniesRegistered": "No companies registered yet",
    "noCompaniesRegisteredDesc": "Add your first partner company to start generating invoices.",
    "noCompaniesFound": "No companies found",
    "noCompaniesFoundDesc": "Try adjusting your search query.",
    "nameRequired": "Company Name is required",
    "codeRequired": "Company Code is required",
    "phoneRequired": "Phone Number is required",
    "addressRequired": "Street Address is required",
    "cityRequired": "City is required",
    "postalRequired": "Postal Code is required",
    "taxRequired": "Tax ID is required",
    "codeAlreadyExists": "Company code already exists",
    "deleteCompany": "Delete Company",
    "deleteCompanyTitle": "Delete Company?",
    "deleteCompanyConfirm": "Are you sure you want to delete {{name}} ({{code}})? This will permanently remove the company.",
    "yesDelete": "Yes, Delete",
    "editDetails": "Edit Details",
    "saveChanges": "Save Changes",
    "companyFinancialReport": "Company Financial Report",
    "financialSummary": "Financial Summary",
    "totalRevenue": "TOTAL REVENUE",
    "netProfit": "NET PROFIT",
    "outstanding": "OUTSTANDING",
    "monthlyFinancialOverview": "MONTHLY FINANCIAL OVERVIEW",
    "companyFinancialBreakdown": "COMPANY FINANCIAL BREAKDOWN",
    "month": "MONTH",
    "revenue": "REVENUE",
    "invoicesSent": "INVOICES SENT",
    "invoicesPaid": "INVOICES PAID",
    "amountPaid": "AMOUNT PAID",
    "pending": "PENDING",
    "overdue": "OVERDUE",
    "dataConsolidated": "Data consolidated for all companies",
    "exportPdfReport": "Export PDF Report",
    "confirmAddCompany": "Are you sure that you want to add {{name}} to the system list?",
    "successfullyDeleted": "Successfully Deleted",
    "deletedDesc": "{{name}} has been successfully removed from the system.",
    "successfullyAdded": "Successfully Added",
    "addedDesc": "{{name}} has been added to the system list."
  },
    "hotelReservations": {
      "title": "Hotel Reservations",
      "subtitle": "Track hotel reservation vouchers, room allocations, check-in dates, and deposit tracking.",
      "tabReservations": "Reservations",
      "tabRequests": "Reservation Requests",
      "newReservation": "New Reservation",
      "createTentative": "Tentative Reservation",
      "createConfirmation": "Confirmed Reservation",
      "allReservations": "All Reservations Listing",
      "searchPlaceholder": "Search by reservation #, guest, or hotel...",
      "totalBooked": "Total booked",
      "totalReservations": "total reservations",
      "reservations": "reservations",
      "showing": "Showing",
      "hotel": "Hotel",
      "guestName": "Guest Name",
      "checkIn": "Check In",
      "checkOut": "Check Out",
      "rooms": "Rooms",
      "roomType": "Room Type",
      "nights": "Nights",
      "resNo": "Reservation #",
      "reqNo": "Request #",
      "amount": "Amount",
      "expiredPayment": "Expired payment",
      "manuallyCancelled": "Manually cancelled",
      "allRequests": "All Requests",
      "pendingRequests": "Pending",
      "confirmedRequests": "Confirmed",
      "rejectedRequests": "Rejected",
      "noBookingsFound": "No bookings found",
      "noBookingsFoundDesc": "There are no records matching your query.",
      "hotelReservationRequests": "Hotel Reservation Requests",
      "request": "Request",
      "backToListing": "Back to Listing",
      "confirmedReservationDetails": "Confirmed Reservation Details",
      "reservationDetails": "Reservation Details",
      "reservationNumber": "Reservation Number",
      "invoiceNumber": "Invoice Number",
      "referenceNumber": "Reference Number",
      "serialNumber": "Serial Number",
      "dueDate": "Due Date",
      "billFrom": "BILL FROM",
      "billTo": "BILL TO",
      "employeeName": "Employee Name",
      "companyNumber": "Company Number",
      "employeeId": "Employee ID",
      "companyEmail": "Company Email",
      "entityCompany": "Entity / Company",
      "companyTaxNumber": "Company Tax Number",
      "clientCompany": "Guest / Group Name",
      "guestGroupName": "Guest / Group name",
      "guestGroupNameRequired": "Guest / Group name is required",
      "streetAddress": "Street Address",
      "cityCountry": "City / Country",
      "accommodationsBreakdown": "Accommodations Breakdown",
      "hotelDetails": "Hotel Details",
      "numNight": "#Night",
      "numRoom": "#Room",
      "adult": "Adult",
      "child": "Child",
      "meals": "Meals",
      "dayRate": "DayRate",
      "mealsRate": "Meals Rate",
      "total": "Total",
      "subtotal": "Subtotal",
      "taxVat": "Tax / VAT",
      "totalDue": "Total Due",
      "remainingBalance": "Remaining Balance",
      "advancePayment": "Advance Payment (Deposit)",
      "hasAdvancePayment": "Has Advance Payment?",
      "advancePaymentAmount": "Advance Payment Amount",
      "exchangeRate": "EXCHANGE RATE",
      "totalDueIdr": "Total Due (IDR)",
      "totalDueSar": "Total Due (SAR)",
      "paymentInstructions": "Payment Instructions",
      "bankName": "Bank Name",
      "accountName": "Account Name",
      "usdAccount": "USD Account",
      "idrAccount": "IDR Account",
      "printInvoice": "Print Invoice",
      "downloadPdf": "Download PDF",
      "viewPdf": "View PDF",
      "approvalWorkflowStatus": "Approval Workflow Status",
      "madinahAccountant": "Madinah Accountant",
      "confirmedAt": "Confirmed",
      "awaitingReviewYourLevel": "Awaiting Review (Your Level)",
      "awaitingReview": "Awaiting Review",
      "approvalsComplete": "1 of 1 Approvals Complete — Reservation Confirmed",
      "approvalsPending": "0 of 1 Approvals Complete — Reservation Pending",
      "readyForPayment": "Ready for payment processing",
      "availableOperations": "Available Operations",
      "paymentSettled": "✓ Payment Fully Settled (Closed)",
      "markAsPaid": "Mark as Paid",
      "sendConfirmation": "Send Confirmation",
      "sendConfirmationRequest": "Send Confirmation Request",
      "uploadPaymentInvoice": "Upload Payment Invoice",
      "paymentProofRequired": "⚠️ Payment proof required",
      "paymentProofUploaded": "Payment Proof Uploaded",
      "readyToReview": "Ready to review",
      "viewProof": "View Proof",
      "changePaymentProof": "Change Payment Proof",
      "dragDropUpload": "Drag & drop or click to upload",
      "uploadSupports": "Supports: PDF, JPG, PNG (max 10MB)",
      "notes": "Notes",
      "notesPlaceholder": "Add payment notes or special instructions...",
      "saveNote": "Save Note",
      "yourDecision": "Your Decision",
      "decisionDesc": "As the Madinah Accountant, please confirm verification of the Requested Reservation.",
      "rejectRequest": "Reject Request",
      "approve": "Approve",
      "confirmApproval": "Confirm Approval",
      "confirmApprovalDesc": "Please enter the confirmation number to proceed with the approval of this reservation.",
      "confirmAndApprove": "Confirm & Approve",
      "approvedSuccessfully": "Approved Successfully",
      "approvedSuccessfullyDesc": "The reservation has been approved and confirmed. A notification has been sent to the requester.",
      "paymentTransferPhotoPdf": "Payment Transfer Photo / PDF",
      "downloadImage": "Download Image",
      "addRoom": "Add Room",
      "createHotelReservation": "Create New Hotel Reservation",
      "stayType": "Stay Type",
      "tentativeReservation": "Tentative Reservation",
      "confirmationReservation": "Confirmation Reservation",
      "hotelName": "Hotel Name",
      "hotelNamePlaceholder": "Enter Hotel Name (e.g. SAFWAT AL MADINAH)",
      "checkInDate": "Check-In Date",
      "checkOutDate": "Check-Out Date",
      "nightsDuration": "#Nights (Duration)",
      "adultsCount": "Adults Count",
      "childrenCount": "Children Count",
      "mealPlan": "Meal Plan",
      "pricePerNight": "DayRate (Price / Night)",
      "preview": "Preview",
      "action": "Action",
      "createTentativeReservation": "Create Tentative Reservation",
      "confNo": "Confirmation #",
      "confirmReservation": "Confirm Reservation",
      "approvedByKarim": "Approved by Karim",
      "of": "of",
      "billToClient": "BILL TO (CLIENT)",
      "createNewHotelReservation": "Create New Hotel Reservation",
      "reservation": "Reservation",
      "dayRatePricePerNight": "DayRate (Price / Night)",
      "advancePaymentPlaceholder": "Enter DP / Deposit amount...",
      "cifNumber": "CIF / Company Number",
      "swiftCode": "SWIFT Code",
      "bankBranchAddress": "Bank Branch Address"
    },
  "settings": {
    "title": "System Settings",
    "subtitle": "Manage your profile, team members, operating branches, notifications, and security.",
    "profile": "Profile",
    "team": "Manage Team",
    "branches": "Branches",
    "notifications": "Notifications",
    "security": "Security",
    "exchangeRates": "Exchange Rates",
    "dataBackup": "Data Backup",
    "services": "Services",
    "companyInfo": "Company Info",
    "hbManagement": "HB Management",
    "branchManagement": "Branch & Office Management",
    "locationAddress": "Location / Address",
    "branchName": "Branch Name",
    "addBranch": "Add Branch",
    "addMember": "Add Member",
    "taxVatConfig": "Tax / VAT Configuration",
    "taxVatSubtitle": "Set the default tax or VAT percentage applied to Confirmations",
    "taxNumber": "Tax Number",
    "taxInfo": "Tax Information",
    "taxInfoSubtitle": "Set your company tax identification number for confirmations",
    "bankInfo": "Bank Account Information",
    "roomTypes": "Room Types",
    "mealPlans": "Meal Plans",
    "name": "Full Name",
    "email": "Email Address",
    "phone": "Phone Number",
    "role": "Role",
    "password": "Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm Password",
    "downloadBackup": "Download Full Backup (.json)",
    "exportCsvData": "Export Modular CSV Data",
    "personalDetails": "Personal Details",
    "profileDisplayPicture": "Profile Display Picture",
    "photoGuidelines": "PNG, JPG or GIF up to 5MB. 400×400px recommended.",
    "changePhoto": "Change Photo",
    "companyAssignment": "Company Assignment (Read-Only)",
    "readOnly": "Read-Only",
    "registeredCompany": "Registered Company",
    "defaultBranch": "Default Branch",
    "employeeId": "Employee ID",
    "department": "Department",
    "jobTitle": "Job Title",
    "currentPassword": "Current Password",
    "enterNewPassword": "Enter new password",
    "reenterNewPassword": "Re-enter new password",
    "updatePassword": "Update Password",
    "activeSessions": "Active Operator Sessions",
    "loginActivityLogs": "Login Activity Logs (Last 5 attempts)",
    "timestamp": "Timestamp",
    "ipAddress": "IP Address",
    "operatingAgent": "Operating Agent",
    "revoke": "Revoke",
    "current": "Current",
    "confirmationNotifications": "Confirmation Notifications",
    "approvalNotifications": "Approval Notifications",
    "systemNotifications": "System & Security Notifications",
    "alertType": "Alert Type",
    "emailChannel": "Email",
    "inAppChannel": "In-App",
    "notifNewInvoiceTitle": "New confirmation submitted",
    "notifNewInvoiceDesc": "Notify when a branch team submits a new confirmation.",
    "notifApprovedTitle": "Confirmation approved",
    "notifApprovedDesc": "Notify when a confirmation has passed final review and is cleared.",
    "notifRejectedTitle": "Confirmation rejected",
    "notifRejectedDesc": "Notify if a confirmation is rejected or returned for corrections.",
    "notifPaymentTitle": "Payment received",
    "notifPaymentDesc": "Receive confirmation when payment transitions succeed.",
    "notifAssignedTitle": "Approval request assigned",
    "notifAssignedDesc": "Receive alerts when a new queue item lands in your desk.",
    "notifApprovalDoneTitle": "Approval completed",
    "notifApprovalDoneDesc": "Notification when downstream team processes your cleared queues.",
    "notifApprovalOverdueTitle": "Approval overdue",
    "notifApprovalOverdueDesc": "Receive critical notification if action queue items cross due limits.",
    "notifSecurityTitle": "Security alerts",
    "notifSecurityDesc": "Get notified about login attempts from unknown IP locations.",
    "notifTeamChangesTitle": "Team member changes",
    "notifTeamChangesDesc": "Notify when super admins add or remove platform operators.",
    "notifMaintenanceTitle": "System maintenance",
    "notifMaintenanceDesc": "Get alerts before scheduled system upgrades and offlines.",
    "dailyExchangeRate": "Daily Exchange Rate",
    "exchangeRateSubtitle": "Manually update exchange rates daily for confirmation calculations",
    "todayExchangeRate": "Today's Exchange Rate",
    "rateHistory": "Rate History",
    "updated": "Updated",
    "saveRates": "Save Rates",
    "backupInfrastructure": "System Data Backup & Infrastructure Export",
    "backupSubtitle": "Generate and download full database snapshot backups for offline disaster recovery.",
    "downloadFullBackup": "Download Full Backup (.json)",
    "fullBackupSubtitle": "Includes Invoices, Reservations, Clients, and Settings",
    "generatingBackup": "Generating Backup...",
    "autoCloudBackup": "Automatic Cloud Backup",
    "activeSnapshot": "Active (Auto Snapshot)",
    "serverDeployments": "Server Deployments",
    "synchronizedGit": "Synchronized (Git Main)",
    "members": "Members",
    "addNewMember": "Add New Team Member",
    "editMember": "Edit Team Member",
    "deleteMember": "Remove Team Member",
    "confirmDeletion": "Confirm Deletion",
    "confirmDeletionDesc": "Are you sure you want to remove {{name}} ({{email}}) from the team?",
    "deleteWarning": "Warning: This action cannot be undone. This user will lose all access to the system immediately.",
    "yesRemove": "Yes, Remove",
    "confirmAction": "Confirm Action",
    "confirmAddMember": "Are you sure you want to add this member?",
    "confirmAddMemberDesc": "This action will send an invitation email to the new team member so they can access the platform.",
    "yesAddMember": "Yes, Add Member",
    "memberAddedSuccess": "Member Added Successfully!",
    "memberAddedSuccessDesc": "The new team member has been added and an invitation email has been sent.",
    "errorsFound": "{{count}} errors found. Please fix them before submitting.",
    "fullNameRequired": "Full Name is required",
    "emailRequired": "Email Address is required",
    "branchRequired": "Branch is required. Add in settings first.",
    "autoGeneratedEmpId": "Auto-generated if left blank",
    "assignedBranch": "Assigned Branch / Office",
    "rolesMatrix": "Roles & Permissions Matrix",
    "rolesMatrixSubtitle": "Overview of default permission credentials across system roles",
    "permission": "Permission",
    "createConfirmations": "Create Confirmations",
    "approveConfirmations": "Approve Confirmations",
    "manageCompanies": "Manage Companies",
    "viewReports": "View Reports",
    "manageTeam": "Manage Team",
    "branchStats": "Branch Statistics",
    "totalBranches": "Total Branches",
    "activeBranches": "Active Branches",
    "totalStaffAcrossBranches": "Total Staff Across Branches",
    "createBranch": "Create New Branch",
    "createBranchSubtitle": "A branch contains all your working file history.",
    "companyIdentity": "Company Identity",
    "companyIdentitySubtitle": "Update your company or entity name displayed on confirmations",
    "contactInfo": "Contact Information",
    "contactInfoSubtitle": "Update your company phone number and contact details",
    "defaultNotes": "Default Notes",
    "defaultNotesSubtitle": "Standard notes text included at the bottom of confirmation documents",
    "termsAndConditions": "Terms & Conditions",
    "termsAndConditionsSubtitle": "Standard payment terms included on confirmations",
    "bankAccountSubtitle": "Add your company bank account details for confirmations",
    "bankName": "Bank Name",
    "accountHolderName": "Account Holder Name",
    "idrAccountNumber": "IDR Account Number",
    "usdAccountNumber": "USD Account Number",
    "bankBranchAddress": "Bank Branch Address",
    "cifNumber": "CIF / Company Number",
    "swiftCode": "SWIFT Code",
    "bankBranchAddressPlaceholder": "Enter bank branch address",
    "cifNumberPlaceholder": "Enter CIF / Company number",
    "swiftCodePlaceholder": "Enter SWIFT code (e.g. BDINIDJA)",
    "roomTypeSubtitle": "Manage standard hotel room types available in the system",
    "mealPlanSubtitle": "Manage hotel meal plans available in the system",
    "addRoomType": "Add Room Type",
    "addMealPlan": "Add Meal Plan",
    "roomTypeName": "Room Type Name",
    "mealPlanName": "Meal Plan Name",
    "mealPlanCode": "Meal Plan Code",
    "exportHistory": "Export History",
    "exportType": "Export Type",
    "filename": "Filename",
    "exportedBy": "Exported By",
    "fullBackupDesc": "Exports a complete JSON payload containing all active ledger records, hotel reservations, client directory data, and exchange rate parameters for offline archival.",
    "noExportThisSession": "No export this session",
    "lastExport": "Last export: {{time}}",
    "hostingInfrastructure": "Hosting Infrastructure & Database Backup",
    "productionDbDeployment": "Production Database & Web Server Deployment",
    "authorizedControllers": "Authorized IT Controllers",
    "cloudBackupNote": "* Automatic cloud backups run continuously on your active production database server.",
    "adminItOnly": "System Admin & IT Only",
    "accessRestricted": "Access Restricted",
    "backupAccessRestrictedDesc": "This system backup section is strictly restricted. Only IT Administrators (Dimas & Ali) are authorized to access and download full database backups.",
    "exportCsvDesc": "Download individual datasets compatible with Microsoft Excel & Google Sheets",
    "exportInvoicesDesc": "All financial confirmation entries",
    "exportReservationsDesc": "Hotel reservation & room data",
    "exportCompaniesDesc": "Client company & partner data",
    "exportHistoryDesc": "Audit log of data exports. If files are missing, click \"Re-Download\" to extract a new copy.",
    "redownload": "Re-Download",
    "redownloadDesc": "Re-download this backup copy",
    "noExportHistory": "No export history recorded yet. Generating a backup will log entries here automatically.",
    "loadingExportHistory": "Loading export history log...",
    "maintenanceBroadcastTitle": "System Maintenance Broadcast",
    "maintenanceBroadcastDesc": "Instantly broadcast maintenance schedules, upgrades, or module improvements to all users.",
    "scopeLabel": "Maintenance Scope Target",
    "scopeAll": "All System (Full System)",
    "scopeReservations": "Hotel Reservations Module",
    "scopeInvoices": "Invoices & Payments Module",
    "scopeApprovals": "Approval Requests Module",
    "scopeSettings": "Settings & Database Module",
    "scheduleTimeLabel": "Maintenance Schedule (Date & Time)",
    "scheduleTimePlaceholder": "Example: Tonight at 23:00 - 23:30 WIB",
    "urgencyLabel": "Urgency Level",
    "urgencyNormal": "Normal (Routine Information)",
    "urgencyHigh": "High (Potential Downtime / Disruption)",
    "messageLabel": "Maintenance Announcement Message",
    "messagePlaceholder": "Describe the upgrade, maintenance scope, or instructions for users...",
    "quickTemplates": "Quick Templates",
    "tplServerUpgrade": "Server & Performance Upgrade",
    "tplHotelModule": "Reservation Module Maintenance",
    "tplDatabaseSync": "Database Optimization & Sync",
    "livePreview": "Live User Notification Preview",
    "sendBroadcastBtn": "Send Broadcast Now",
    "sendingBroadcast": "Sending Broadcast...",
    "confirmBroadcastTitle": "Confirm Maintenance Broadcast",
    "confirmBroadcastMsg": "Are you sure you want to broadcast this maintenance notice to all users? In-App and Email notifications will be sent immediately.",
    "broadcastSuccess": "System maintenance notice broadcasted successfully to all users!",
    "maintenanceLocksTitle": "Module Maintenance Status & Lock Switches",
    "maintenanceLocksDesc": "Lock regular user access during maintenance. IT Team (Dimas & Ali) retains full bypass access.",
    "bypassActive": "IT Bypass: Active (Dimas & Ali)",
    "itBypassHeader": "Maintenance Lock Active (IT Bypass Access)",
    "lockModuleBtn": "Lock This Module",
    "unlockModuleBtn": "Unlock Module",
    "lockSystemBtn": "Lock Entire System",
    "unlockSystemBtn": "Unlock System",
    "statusLocked": "Locked",
    "statusActive": "Active",
    "statusEmergencyLocked": "EMERGENCY LOCKED",
    "pageClosedForUsers": "Page closed for regular users.",
    "pageNormalForUsers": "Accessible normally by all users.",
    "systemClosedForUsers": "All modules locked except Login & IT Settings.",
    "systemNormalForUsers": "Entire system operating normally.",
    "autoLockOnBroadcast": "Also lock selected module when broadcast is sent",
    "maintenanceScreen": {
      "badge": "Maintenance Mode Active",
      "closedTitle": "{{module}} is Temporarily Closed",
      "subtitle": "This page is undergoing maintenance or infrastructure upgrades by the IT Team.",
      "scheduleLabel": "Estimate / Schedule:",
      "detailsLabel": "Details:",
      "defaultMsg": "Periodic system updates are in progress to maintain data integrity.",
      "notice": "Form access and data processing in this module are temporarily disabled to prevent data corruption. Please contact the IT Administrator (Ali / Dimas) for urgent assistance.",
      "backDashboard": "Back to Main Dashboard",
      "openInvoices": "Open Confirmations Module"
    }
  },
  "auth": {
    "welcome": "Welcome",
    "welcomeBack": "Welcome Back",
    "signInDesc": "Sign in to your account to continue",
    "emailOrPhone": "Email or Phone Number",
    "enterPassword": "Enter your password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "resetPasswordTitle": "Reset your password",
    "resetPasswordDesc": "Enter your email address and we'll send you a reset link.",
    "emailAddress": "Email Address",
    "enterEmail": "Enter your email",
    "sendResetLink": "Send Reset Link",
    "sending": "Sending...",
    "backToSignIn": "Back to Sign In",
    "checkYourEmail": "Check your email",
    "resetLinkSent": "We've sent a password reset link to {{email}}. The link will expire in 30 minutes.",
    "didntReceiveEmail": "Didn't receive the email?",
    "resend": "Resend",
    "resending": "Resending...",
    "createNewPassword": "Create new password",
    "enterNewPasswordDesc": "Please enter your new password below.",
    "newPassword": "New Password",
    "enterNewPassword": "Enter new password",
    "confirmPassword": "Confirm Password",
    "confirmNewPassword": "Confirm new password",
    "resetPassword": "Reset Password",
    "resetting": "Resetting...",
    "resetCompleteTitle": "Password Reset Complete",
    "resetCompleteDesc": "Your password has been successfully reset. You can now use your new password to sign in.",
    "emailOrPhoneRequired": "Email or phone number is required",
    "validEmailRequired": "Please enter a valid email address",
    "passwordRequired": "Password is required",
    "passwordMinLength": "Password must be at least 6 characters",
    "passwordsDoNotMatch": "Passwords do not match",
    "enterEmailRequired": "Please enter your email address",
    "tokenMissing": "Password reset token is missing. Please request a new link.",
    "invalidCredentials": "Invalid credentials. Please try again.",
    "failedToSendResetLink": "Failed to send reset link. Please try again.",
    "failedToResetPassword": "Failed to reset password. Token may be invalid or expired."
  },
  "expenses": {
    "title": "My Expenses",
    "subtitle": "Track, submit, and manage all your corporate expense claims & reimbursement statuses.",
    "submitNewClaim": "Submit New Claim",
    "exportExcel": "Export Excel",
    "totalClaims": "Total Claims",
    "pendingApproval": "Pending Approval",
    "approvedPayout": "Approved / Payout Due",
    "settledPaid": "Settled & Paid",
    "allClaims": "All Claims",
    "pending": "Pending",
    "approved": "Approved",
    "paid": "Paid",
    "rejected": "Rejected",
    "searchPlaceholder": "Search claim ID, category, or note...",
    "claimId": "Claim ID",
    "date": "Date",
    "category": "Category",
    "amount": "Amount",
    "bank": "Bank Destination",
    "approvalChain": "Approval Chain",
    "status": "Status",
    "receipt": "Receipt",
    "actions": "Actions",
    "viewDetail": "View Detail",
    "viewTransferProof": "Transfer Receipt",
    "viewApprovalDetail": "Approval Workflow",
    "claimDetails": "Claim Details & Attached Receipts",
    "receiptPreview": "Receipt Document Preview",
    "noReceipts": "No receipt attached"
  },
  "submitExpense": {
    "title": "Submit Corporate Expense",
    "subtitle": "Upload valid receipts, invoices, and vouchers for departmental review and finance audit.",
    "dropzoneTitle": "Drag & drop receipts here or click to browse",
    "dropzoneHint": "Supported formats: PDF, JPG, PNG, WEBP (Max 15MB per file). Multiple files allowed.",
    "category": "Expense Category",
    "selectCategory": "Select category...",
    "expenseDate": "Expense Date",
    "amount": "Expense Amount",
    "currency": "Currency",
    "merchant": "Merchant / Vendor Name",
    "taxVatId": "Tax / VAT ID (Optional)",
    "purpose": "Business Purpose / Description",
    "bankDestination": "Bank Account Destination",
    "selectBank": "Select employee bank account...",
    "submitClaim": "Submit Claim for Approval",
    "submitting": "Submitting Claim...",
    "successTitle": "Expense Claim Submitted Successfully!",
    "successDesc": "Your claim has been registered with reference {{id}} and routed to your direct manager for review.",
    "trackClaim": "Track in My Expenses"
  },
  "approvals": {
    "title": "Finance Approvals Dashboard",
    "subtitle": "Audit approved claims, prepare bank disbursements, export validated listings to your ERP, or batch settle via Bank API.",
    "pendingFinance": "Pending Finance Audit",
    "readyDisburse": "Ready for Disbursement",
    "totalValue": "Total Claim Value",
    "processedMonth": "Processed This Month",
    "addToPayroll": "Add to Payroll",
    "delete": "Delete",
    "deleteConfirmTitle": "Delete Selected Claims",
    "deleteConfirmDesc": "Are you sure you want to delete {{count}} selected claim(s)? This action cannot be undone.",
    "deleteWarning": "This action will remove the selected claim records permanently from the ready queue.",
    "exportAndSchedule": "Export Excel & Confirm",
    "transferToBank": "Transfer to Bank",
    "selectAll": "Select All",
    "batchAction": "Batch Actions",
    "employee": "Employee",
    "department": "Department",
    "reviewAudit": "Review & Audit Claim",
    "payrollSuccess": "Successfully Added to Payroll Cycle",
    "bankSuccess": "Transfer Initiated Successfully"
  },
  "expenseApproval": {
    "title": "Claim Audit & Approval",
    "subtitle": "Review and process pending reimbursement claim and audit receipt documents.",
    "claimProfile": "Claim Profile",
    "workflowStepper": "Approval Chain Stepper",
    "workflowSubtitle": "3-Tier Executive Authorization Chain",
    "receiptView": "Digital Receipt Document",
    "vatSummary": "VAT & Tax Breakdown",
    "transferAmount": "Transfer Amount",
    "rejectClaim": "Reject Claim",
    "requestClarification": "Request Clarification",
    "approveClaim": "Approve Claim",
    "itMode": "IT Testing & Access Mode",
    "resetSimulation": "Reset Simulation",
    "approverSimulation": "Approver Authority Simulation:",
    "flowShortcuts": "Flow Page Shortcuts:",
    "initiateReimbursementShortcut": "Initiate Reimbursement",
    "preExecutionPaymentShortcut": "Pre-Execution Payment",
    "employeeBankDataShortcut": "Employee Bank Data",
    "fullItBypass": "Full IT Bypass",
    "disbursedCompleteTitle": "Payment Completed & Settled",
    "disbursedCompleteDesc": "Funds have been successfully transferred to {{name}}'s account ({{bank}} - {{account}}).",
    "viewTransferProofAndAudit": "View Transfer Proof & Audit Certificate",
    "accessDeniedApprover": "Access Denied: Not an Authorized Approver",
    "accessDeniedDesc": "Only 3 authorized executives can approve (Mr. Hesham Mokhtar, Mr. Khalid Idriss, and Mr. Emad Moustafa). Super Admin and other accounts do not possess approval authority.",
    "notYourTurn": "Not Your Turn to Approve",
    "notYourTurnDesc": "You are authenticated as {{name}}. However, Step {{step}} approval is currently under the exclusive authority of {{approver}} ({{role}}).",
    "yourTurn": "Your Turn: {{name}}",
    "yourTurnDesc": "Approval authority for Step {{step}} ({{role}}) is active.",
    "approveStage": "Approve Step {{step}} ({{name}})",
    "fullyApprovedWaitingDisbursement": "Claim Fully Approved (3/3 Complete)",
    "fullyApprovedHoldNotice": "3-Tier Executive Approval Completed. Automated bank disbursement is on hold pending Bank BNI API integration finalization.",
    "approvalDisabledWaiting": "Waiting for Step {{step}} Approval ({{approver}})",
    "approvalDisabledNoAuth": "Approval Disabled (Requires Approver Account)",
    "claimClosedNotes": "This claim has been approved and recorded in the financial system.",
    "noApprovalNotesPermitted": "You cannot submit approval notes at this stage.",
    "approvalNotesPlaceholder": "Add approval notes or feedback if requesting clarification...",
    "executionStatusLabel": "Execution Status",
    "executionStatusValue": "3/3 Executive Approval Completed",
    "cryptoValidationLabel": "Cryptographic Validation",
    "cryptoValidationValue": "SHA-256 Verified Immutable",
    "claimArchivedLog": "Claim has been completed and recorded in the audit log.",
    "statusTransferred": "Status: Paid & Disbursed",
    "statusTransferredDesc": "This claim has been successfully settled via Host-to-Host banking transaction and funds have been credited to {{name}}'s account.",
    "authorized": "Authorized",
    "stageApprovedTitle": "Step {{step}} Approved!",
    "fullyApprovedMsg": "Reimbursement claim {{claimId}} has been fully approved (3/3) by Mr. Emad Moustafa.",
    "stepApprovedMsg": "Step {{step}} approval ({{name}}) was recorded successfully. Claim forwarded to next stage.",
    "accessDeniedTitle": "Access Denied",
    "accessDeniedRejectMsg": "You are not authorized to reject the claim at this stage.",
    "accessDeniedClarifyMsg": "You are not authorized to request clarification at this stage.",
    "accessDeniedDisburseMsg": "Only Mr. Emad Moustafa (Financial Controller / Treasury) can initiate bank payout.",
    "claimRejectedTitle": "Claim Rejected",
    "claimRejectedMsg": "Reimbursement claim {{claimId}} has been rejected.",
    "clarificationRequestedTitle": "Clarification Requested",
    "clarificationRequestedMsg": "A notification has been sent to {{name}} requesting additional details.",
    "fullSettled": "PAID IN FULL"
  },
  "initiateReimbursement": {
    "title": "Initiate Bank Reimbursement",
    "subtitle": "Review claim summary, select company funding debit account, and trigger automated API host-to-host bank payout.",
    "claimSummary": "Approved Claim Summary",
    "fundingSource": "Corporate Funding Source",
    "beneficiaryDetails": "Beneficiary Bank Details",
    "attentionController": "ATTENTION CONTROLLER",
    "attentionDesc": "By clicking Initiate Payment below, you authorize the immediate dispatch of funds to the verified employee bank account details shown above.",
    "initiatePayment": "Initiate Payment",
    "cancelExecution": "Cancel Execution",
    "verifiedAccount": "Verified Account",
    "transferToBank": "Direct Bank Transfer",
    "apiIntegrated": "Active • API Integrated",
    "apiInactive": "Inactive • API Disconnected",
    "transferDesc": "Initiate instant local transfer settlement via automated Host-to-Host (SNAP BI) pathway.",
    "gatewayCallout": "Directly connected to {{bank}} API Gateway (SNAP BI TLS 1.3). Corporate account balance verified.",
    "gatewayInactiveCallout": "{{bank}} Gateway is currently inactive or not configured. Contact Super Admin IT to activate it.",
    "gatewayInactiveWarning": "Bank automated transfer route is suspended because the gateway status is inactive.",
    "disbursedAlertTitle": "STATUS: FUNDS TRANSFERRED & SETTLED",
    "disbursedAlertDesc": "The payment transaction for this claim has been successfully processed to the beneficiary account above. Duplicate payments are disabled for security.",
    "viewTransferProofAndAudit": "View Transfer Proof & Audit"
  },
  "setupBeneficiary": {
    "title": "Setup Beneficiary Account",
    "subtitle": "Configure and verify employee banking destination for automated Host-to-Host API payouts (SNAP BI).",
    "clearingDomestic": "Domestic Clearing Network of Bank Indonesia (SNAP BI / BI-FAST TLS 1.3)",
    "clearingInternational": "International & Saudi Arabian Real-Time Express Clearing (SARIE)",
    "bankName": "Bank Name",
    "targetCurrency": "Target Currency",
    "accountHolder": "Account Holder Name",
    "accountHolderNote": "Must match the legal registration on official ID / bank record.",
    "accountNumber": "Account Number",
    "accountNumberPlaceholder": "Account Number for {{bank}} ({{min}}-{{max}} Digits)",
    "checkAccount": "Inquire & Verify Account",
    "checkingAccount": "Inquiring Bank...",
    "accountVerifiedOfficial": "Officially Verified via {{network}}",
    "accountNameMatched": "Registered Name at Bank: {{name}}",
    "accountStatusActive": "Account Status: ACTIVE",
    "accountNotFound": "Account number {{account}} was NOT FOUND or INACTIVE on {{bank}} server (SNAP BI Response: 404 ACCOUNT_NOT_FOUND). Please enter a valid registered account number.",
    "accountInquiryFailed": "Failed to connect to banking inquiry gateway.",
    "formatValid": "Valid Account Number Format ({{min}}-{{max}} Digits)",
    "iban": "IBAN (24 Characters)",
    "ibanOptional": "IBAN (Not required for Indonesian domestic transfers)",
    "ibanOptionalPlaceholder": "Not required for Indonesian local bank transfers (Optional)",
    "ibanRequired": "IBAN Required (Saudi Arabia 24-Characters Format)",
    "ibanValid": "IBAN 24-Characters Valid",
    "ibanInvalid": "IBAN must contain exactly 24 characters (starting with SA)",
    "swift": "SWIFT / BIC Code",
    "branchLocation": "Bank Branch / Location",
    "saveAccount": "Save & Verify Account Details",
    "accountVerified": "Beneficiary Account Verified!",
    "modalVerifiedDesc": "Bank account credentials for {{name}} at {{bank}} have been verified and saved for instant reimbursement settlement.",
    "proceedToReimbursement": "Proceed to Reimbursement"
  },
  "preExecutionPayment": {
    "reviewTitle": "Pre-Execution Payment Review",
    "reviewSubtitle": "Perform dual-factor authorization. Ensure the audit trail complies with standard corporate governance thresholds.",
    "tunnelTitle": "API Settlement Tunnel",
    "tunnelSubtitle": "Host-to-Host connection handshake.",
    "dispatchedTitle": "Payout Dispatched Successfully",
    "dispatchedSubtitle": "Funds successfully routed and acknowledged by gateway. Audit receipts compiled.",
    "confirmAuthorize": "Confirm & Authorize Transfer",
    "enterOtp": "Enter 2FA OTP Code",
    "otpPlaceholder": "6-digit OTP",
    "settlePaid": "PAID COMPLETED",
    "downloadVoucher": "Download PDF Receipt",
    "auditTrail": "Compliance & Execution Audit Trail",
    "exportCertificate": "Export Full Audit Certificate",
    "copyHash": "Copy Master Audit Hash",
    "hashCopied": "Hash Copied!",
    "inspect": "Inspect",
    "stepOf": "Step {{current}} of {{total}}",
    "verifiedImmutable": "Verified & Immutable",
    "authorizedSigner": "Authorized Signer / Gateway",
    "authProof": "Authentication Proof",
    "telemetry": "Audit Telemetry & Network Trail",
    "digitalSignature": "Digital SHA-256 Audit Signature",
    "governancePolicy": "Governance & Policy Compliance",
    "signerRemarks": "Signer & Execution Remarks",
    "closeInspector": "Close Inspector",
    "nextStep": "Next Step",
    "prevStep": "Prev Step",
    "realtimeLifecycle": "REALTIME API DISPATCH LIFECYCLE",
    "apiHandshake": "API Handshake",
    "balanceVerified": "Balance Verified",
    "dispatching": "Dispatching",
    "traceIdLabel": "Transaction Trace ID",
    "settlementEndpoint": "Settlement Endpoint",
    "estimatedCompletion": "Estimated Completion Time",
    "under30Sec": "< 30 seconds",
    "autoRefreshWarning": "This panel refreshes automatically. Do not reload or navigate away from the page.",
    "otpSentTo": "OTP sent to the mobile phone of {{chiefAccountant}} ({{chiefAccountantRole}}) & {{controller}} ({{controllerRole}}).",
    "resendCodeSec": "Resend code ({{sec}}s)",
    "resendCodeNow": "Resend code now",
    "verifyInvoiceCheckbox": "I verify that the above details conform exactly to approved invoice for {{amount}}.",
    "debitAccountSender": "DEBIT ACCOUNT (SENDER)",
    "creditAccountRecipient": "CREDIT ACCOUNT (RECIPIENT)",
    "settlementRoute": "SETTLEMENT ROUTE",
    "estimatedSpeed": "ESTIMATED SPEED",
    "backToClaim": "Back to Claim",
    "stepMsg1": "Initiating payout transaction for claim {{claim}}...",
    "stepMsg2": "Performing mTLS 1.3 handshake with {{bank}} gateway...",
    "stepMsg3": "Verifying corporate account balance authorization & limits...",
    "stepMsg4": "Transferring funds Host-to-Host directly to {{employee}} ({{bank}})...",
    "stepMsg5": "Transfer completed successfully! Preparing disbursement voucher..."
  },
  "superAdmin": {
    "badge": "Super Admin",
    "title": "Super Admin Dashboard",
    "subtitle": "Manage user permissions, monitor audit logs, and oversee data backups.",
    "refreshData": "Refresh Data",
    "restrictedTitle": "Access Restricted",
    "restrictedDesc": "The Super Admin Mini Dashboard is exclusively reserved for System Administrators (Dimas & Ali). Your current account role does not have authorization to view this panel.",
    "returnToDashboard": "Return to Dashboard",
    "tabs": {
      "permissionMatrix": "Permission Matrix",
      "users": "Users",
      "auditLogs": "System Audit Logs",
      "dataBackup": "Data Backup",
      "systemMaintenance": "System Maintenance",
      "bankingApi": "Banking & API Gateway"
    },
    "bankingApi": {
      "metrics": {
        "snapBiTitle": "SNAP BI",
        "snapBiDesc": "Bank Indonesia Open API Standard",
        "tlsTitle": "Mandatory TLS 1.3",
        "tlsDesc": "PADG BI No. 23/15/PADG/2021",
        "latencyDesc": "BNI H2H Latency",
        "shaTitle": "SHA-256 / RSA",
        "shaDesc": "Digital Asymmetric Signature"
      },
      "form": {
        "title": "Parameter Configuration: {{name}}",
        "subtitle": "Configure Host-to-Host credentials, Base URL, and Webhook for direct bank integration.",
        "testPing": "Test Connection (Ping)",
        "testing": "Testing...",
        "gatewayName": "Gateway Name",
        "gatewayCode": "Gateway Code",
        "environment": "Environment",
        "envSandbox": "Sandbox (Test Simulator)",
        "envProduction": "Production (Live Gateway)",
        "operationalStatus": "Operational Status",
        "active": "Active",
        "inactive": "Inactive",
        "clientId": "Client ID / API Key",
        "clientSecret": "Client Secret",
        "show": "Show",
        "hide": "Hide",
        "merchantCode": "Merchant Code",
        "channelId": "Channel ID",
        "endpointUrl": "Endpoint URL (Host-to-Host)",
        "webhookUrl": "Webhook URL",
        "webhookSecret": "Webhook Secret",
        "ipWhitelist": "IP Whitelist",
        "certificateData": "Public mTLS Certificate (PEM)",
        "saveConfig": "Save Configuration",
        "saving": "Saving..."
      },
      "diagnostics": {
        "title": "SNAP BI Connection Test Results",
        "standardNote": "PADG BI No. 23/15/PADG/2021",
        "handshakeLatency": "Handshake Latency",
        "encryptionProtocol": "Encryption Protocol",
        "cipherSuite": "Cipher Suite",
        "testTimestamp": "Test Timestamp",
        "mandatory": "Mandatory"
      },
      "table": {
        "title": "Banking Settlement & Audit Dispatch Logs",
        "subtitle": "Real-time records of fund disbursement executions from dst_audit_logs database.",
        "colTimestamp": "Timestamp",
        "colExecutor": "Executor",
        "colAction": "Action",
        "colTarget": "Target / Beneficiary",
        "colTraceId": "Trace ID",
        "noAuditLogs": "No settlement transaction history recorded yet.",
        "settlementBadge": "SETTLEMENT"
      },
      "feedback": {
        "saveSuccess": "API configuration for {{name}} saved successfully!",
        "saveError": "Failed to save banking gateway configuration.",
        "pingSuccess": "Handshake test successful ({{ms}}ms) - Status: ONLINE.",
        "pingError": "Failed to connect to Banking API Gateway.",
        "loading": "Loading API integration data..."
      }
    },
    "stats": {
      "totalUsers": "Total Users",
      "bypassApproved": "Bypass Approved",
      "canAddMembers": "Can Add Members",
      "superAdmins": "Super Admins"
    },
    "searchPlaceholder": "Search by name, email, role, or branch...",
    "filterLabel": "Filter:",
    "filters": {
      "allUsers": "All Users",
      "bypassEnabled": "Bypass Enabled",
      "superAdmins": "Super Admins"
    },
    "table": {
      "userRole": "User & Role",
      "branchDept": "Branch / Department",
      "bypassApproval": "Bypass Approval",
      "addMembers": "Add Members",
      "manageLogs": "Manage Logs",
      "viewReports": "View Reports",
      "noUsers": "No matching team members found.",
      "role": "Role:",
      "globalOffice": "Global Office",
      "enabled": "ENABLED",
      "disabled": "DISABLED",
      "superAdminBadge": "SUPER ADMIN",
      "vipBadge": "VIP"
    },
    "feedback": {
      "updatedPerm": "Updated \"{{key}}\" for {{name}} to {{status}}.",
      "updateFailed": "Failed to update permission for {{name}}.",
      "manualLogRecorded": "Manual audit log entry recorded successfully.",
      "logUpdated": "Audit log entry updated successfully.",
      "logDeleted": "Audit log entry removed permanently.",
      "logsLoadFailed": "Failed to load system audit logs. Make sure you are logged in as Super Admin.",
      "deleteFailed": "Failed to delete audit log entry."
    },
    "audit": {
      "searchPlaceholder": "Search logs by user, action, IP, or details...",
      "allActions": "All Actions",
      "filterBypass": "Bypass Confirmations",
      "filterPerms": "Permission Changes",
      "filterAdminNotes": "Admin Notes",
      "filterSecurity": "Security Events",
      "filterSystem": "System Changes",
      "addManualLog": "Add Manual Log",
      "timestamp": "Timestamp",
      "actionEvent": "Action Event",
      "performedBy": "Performed By",
      "targetEntity": "Target Entity",
      "remarksDetails": "Audit Details / Remarks",
      "actions": "Actions",
      "loading": "Loading system audit logs...",
      "noLogs": "No audit log entries matching your criteria.",
      "editTooltip": "Edit Log Remarks",
      "deleteTooltip": "Delete Log Entry",
      "deleteTitle": "Delete Audit Log Entry?",
      "deleteDesc": "Are you sure you want to permanently delete audit record ID: {{id}}? This action cannot be undone.",
      "confirmDelete": "Yes, Delete",
      "dismiss": "Dismiss",
      "badges": {
        "bypass": "BYPASS CONFIRMATION",
        "updatePerms": "UPDATE PERMISSIONS",
        "adminNote": "ADMIN NOTE"
      }
    },
    "modal": {
      "addTitle": "Add System Audit Log",
      "editTitle": "Edit Audit Log Entry",
      "addSubtitle": "Record an operational audit note",
      "editSubtitle": "Log ID: {{id}}",
      "actionLabel": "Action / Event Type *",
      "targetLabel": "Target User / Entity",
      "targetPlaceholder": "e.g. Mr. Khalid, DST-System, finance_token",
      "ipLabel": "IP Address (Optional)",
      "ipPlaceholder": "e.g. 187.52.126.215 or 127.0.0.1",
      "remarksLabel": "Audit Remarks & Details *",
      "remarksPlaceholder": "Enter notes regarding this audit trail entry...",
      "save": "Add Audit Entry",
      "update": "Update Log Entry",
      "saving": "Saving...",
      "options": {
        "manual": "Manual Administrative Note",
        "security": "Security & Access Audit",
        "sysConfig": "System Configuration Changed",
        "updatePerms": "User Permissions Update",
        "financeOverride": "Financial Transaction Override",
        "compliance": "Compliance & Audit Review"
      },
      "errorEmpty": "Please provide details or remarks for this audit log."
    }
  },
  "depositReceipt": {
    "generateTitle": "Generate Official Deposit Receipt",
    "generateSubtitle": "Direct cash/bank deposit voucher with dual-company bank settlement verification",
    "receiptTitle": "OFFICIAL DEPOSIT RECEIPT",
    "receiptSubtitle": "Kingdom of Saudi Arabia / Republic of Indonesia",
    "receiptVoucher": "Payment Receipt Voucher",
    "receiptNo": "Receipt No.",
    "date": "Receipt Date",
    "confirmationDate": "Confirmation Date",
    "referenceNo": "Reference No.",
    "serialNo": "Serial No.",
    "groupNo": "Group No.",
    "payerInfo": "Payer / Client Information",
    "selectRegisteredPayer": "Select Registered Company",
    "orCustomPayer": "Custom / One-Off Client",
    "payerCompanyName": "Payer Company Name",
    "payerCode": "Company Code",
    "payerAgent": "Agent / Contact Person",
    "payerAddress": "Company Address",
    "payerTaxNumber": "Tax / VAT Registration No.",
    "payerEmail": "Email Address",
    "paymentDetails": "Payment Transaction Details",
    "depositAmount": "Deposit Amount",
    "currency": "Currency",
    "paymentDate": "Payment Date",
    "paymentMethod": "Payment Method",
    "forPaymentOf": "For Payment Of (Purpose)",
    "purposePlaceholder": "e.g. Advance Deposit for Ground Handling & Accommodation",
    "notes": "Internal Notes / Remarks",
    "note": "Internal Note / Reference",
    "notesPlaceholder": "Additional notes...",
    "dualBankTitle": "Dual Company Bank Account Verification",
    "beneficiaryBank": "Beneficiary Bank Account (Our Company)",
    "remitterBank": "Remitter Bank Account (Payer Company)",
    "bankName": "Bank Name",
    "accountName": "Account Name",
    "accountNumber": "Account / IBAN Number",
    "swiftCode": "SWIFT Code",
    "bankBranch": "Branch Address",
    "branch": "Branch Address",
    "paymentProof": "Payment Proof / Transfer Slip",
    "uploadProofDesc": "Attach transfer photo or PDF document",
    "dropFileHere": "Click or drag transfer slip here",
    "previewProof": "View Proof",
    "removeProof": "Remove",
    "submitGenerate": "Generate & Preview Official Receipt",
    "generating": "Generating Receipt...",
    "receivedFrom": "Received From",
    "amountInWords": "Amount in Words",
    "amountReceived": "Amount Received",
    "settlementSummary": "Settlement & Bank Details",
    "authorizedSignature": "Authorized Finance Officer",
    "stampAndSeal": "Corporate Verification Seal",
    "printPdf": "Print / Save PDF",
    "close": "Close",
    "language": "Receipt Language",
    "english": "English",
    "indonesian": "Indonesian",
    "arabic": "Arabic",
    "statusValid": "Form Status: Complete & Verified",
    "errAmount": "Please enter a valid deposit amount greater than 0",
    "errPayer": "Please select or enter the payer company name",
    "errBank": "Please provide complete beneficiary and remitter bank details",
    "errProofSize": "File size exceeds maximum limit of 10MB",
    "successGenerated": "Official deposit receipt generated successfully!"
  }
}

